import { render, staticRenderFns } from "./shareResult.vue?vue&type=template&id=4035ba7c&scoped=true"
import script from "./shareResult.vue?vue&type=script&lang=js"
export * from "./shareResult.vue?vue&type=script&lang=js"
import style0 from "./shareResult.vue?vue&type=style&index=0&id=4035ba7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4035ba7c",
  null
  
)

export default component.exports